export const INVOICES_PAGE_SELECTED_QUERY_KEY = "selected";
export const INVOICES_PAGE_SEARCH_QUERY_KEY = "search";
export const INVOICES_PAGE_DETAIL_SEARCH_QUERY_KEY = "detail-search";
export const INVOICES_PAGE_STATUS_QUERY_KEY = "status";
export const INVOICES_PAGE_PERIOD_QUERY_KEY = "period";
export const INVOICES_PAGE_CREATE_PERIOD_QUERY_KEY = "created";
